// extracted by mini-css-extract-plugin
export default {"background_image":"Background_background_image__UG9KR"};